import { addDays, addWeeks, isAfter, isBefore, isSameDay, isValid, subDays, subWeeks } from "date-fns"
import { ReferralReason } from "@/types/__generated__/union-types"

interface DateRange {
  startDate: Date
  endDate: Date
}

export const calculateDateRange = (reason: ReferralReason, callDate: Date): DateRange => {
  const defaultEndDate = addWeeks(callDate, 8) // Add 8 weeks

  let startDate = callDate
  let endDate = defaultEndDate

  switch (reason) {
    case "APPOINTMENT_REGISTRATION":
      startDate = callDate
      endDate = defaultEndDate
      break

    case "EMERGENCY_REGISTRATION":
      startDate = callDate
      endDate = addDays(callDate, 1)
      break

    case "APPOINTMENT_POST_REGISTRATION":
      startDate = subWeeks(subDays(callDate, 1), 3) // Subtract 3 weeks
      endDate = subDays(callDate, 1) // Yesterday
      break

    case "EMERGENCY_POST_REGISTRATION":
      startDate = subDays(callDate, 1)
      endDate = subDays(callDate, 1)
      break

    case "REFERRAL":
      startDate = callDate
      endDate = defaultEndDate
      break
  }

  return { startDate, endDate }
}

type DateValidationData = { dateFrom: Date; dateTo: Date }

const isSameDate = (data: DateValidationData): boolean => isSameDay(data.dateFrom, data.dateTo)

export const isDateRangeValid = (data: DateValidationData): boolean => {
  if (isSameDate(data)) {
    return true
  }

  return (
    isValid(data.dateFrom) &&
    isValid(data.dateTo) &&
    isAfter(data.dateTo, data.dateFrom) &&
    isBefore(data.dateFrom, data.dateTo)
  )
}
